"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var theme_1 = __importDefault(require("../../../../styles/theme"));
var makeStyles_1 = __importDefault(require("../../../../util/makeStyles"));
exports.default = (0, makeStyles_1.default)((0, styles_1.createStyles)({
    root: {
        overflowY: 'auto',
        height: '100%',
    },
    topShadow: {
        borderTop: theme_1.default.divider,
        boxShadow: theme_1.default.shadows.insetTop,
    },
    bottomShadow: {
        boxShadow: theme_1.default.shadows.insetBottom,
        borderBottom: theme_1.default.divider,
    },
    bothShadows: {
        boxShadow: "".concat(theme_1.default.shadows.insetTop, ", ").concat(theme_1.default.shadows.insetBottom),
    },
    alwaysRenderBottomDivider: {
        borderBottom: theme_1.default.divider,
    },
    transparentTopDivider: {
        borderTop: '1px solid transparent',
    },
    transparentBottomDivider: {
        borderBottom: '1px solid transparent',
    },
}));
